export const Match = {
  Excellent: 75,
  Good: 50,
  Fair: 25,
};
